/**
 * DUNAMIS WEAR — Product film popup (canto inferior direito)
 * Preview autoplay + filmes no painel.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-film-popup]');
  if (!root) return;

  var toggle = root.querySelector('[data-film-popup-toggle]');
  var panel = root.querySelector('[data-film-popup-panel]');
  var closeBtn = root.querySelector('[data-film-popup-close]');
  var preview = root.querySelector('[data-film-preview]');
  var videos = Array.prototype.slice.call(root.querySelectorAll('[data-film-popup-video]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-film-popup-dot]'));
  var current = 0;

  function prep(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function ensureSources(video) {
    if (!video) return;
    var sources = video.querySelectorAll('source[data-src]');
    var changed = false;
    sources.forEach(function (source) {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
        changed = true;
      }
    });
    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      changed = true;
    }
    if (changed || video.dataset.lazyLoaded !== 'true') {
      video.dataset.lazyLoaded = 'true';
      if (typeof video.load === 'function') video.load();
    }
  }

  function tryPlay(video) {
    if (!video) return;
    prep(video);
    ensureSources(video);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseAll() {
    videos.forEach(function (video) {
      video.pause();
    });
    if (preview) preview.pause();
  }

  function playVideo(index) {
    if (!videos.length) return;
    current = index;
    videos.forEach(function (video, i) {
      var active = i === index;
      video.hidden = !active;
      video.classList.toggle('is-active', active);
      if (active) {
        video.currentTime = 0;
        tryPlay(video);
      } else {
        video.pause();
      }
    });
    dots.forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function startPreview() {
    if (!preview) return;
    if (root.classList.contains('is-open')) return;
    tryPlay(preview);
  }

  function openPanel() {
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    pauseAll();
    playVideo(current);
  }

  function closePanel() {
    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    pauseAll();
    startPreview();
  }

  toggle.addEventListener('click', function () {
    if (root.classList.contains('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      playVideo(parseInt(dot.getAttribute('data-index'), 10) || 0);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      closePanel();
    }
  });

  /* Autoplay do preview ao carregar + retoma em gesto/visibilidade */
  if (preview) {
    prep(preview);
    preview.setAttribute('autoplay', '');
    preview.dataset.autoplay = 'true';
    preview.setAttribute('preload', 'none');
    ensureSources(preview);

    preview.addEventListener('canplay', startPreview);
    preview.addEventListener('loadeddata', startPreview);
    preview.addEventListener('pause', function () {
      if (!root.classList.contains('is-open') && !document.hidden) {
        window.setTimeout(startPreview, 160);
      }
    });

    var resume = function () {
      startPreview();
    };
    document.addEventListener('touchstart', resume, { passive: true });
    document.addEventListener('click', resume);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) startPreview();
    });

    startPreview();
    window.setTimeout(startPreview, 400);
    window.setTimeout(startPreview, 1200);
  }
})();
